import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';

import { debounceIndexBanksRequest } from '../../requests/banks';
import { FormikSelect, InputSelect } from '../Utils/Select';
import { FormikInput } from '../Utils/Input';

import { bankAccountTypes, paymentTypes, paymentTypesWithCompensation } from './FormOptions';

const BankAccountWithHoldings = ({
  modelKey,
  currentModel,
  paymentTypeAbbr,
  withCompensationFund = false,
  forceSetBank
}) => {
  const dispatch = useDispatch();
  const { values, errors, touched, setFieldTouched, setFieldValue } = useFormikContext();

  const [allBanks, setAllBanks] = useState([]);
  const currentValues = getIn(values, modelKey);
  const { paymentType, bankAccountType } = currentModel;
  const { paymentType: vPaymentType } = currentValues;
  const paymentOptions = withCompensationFund ? paymentTypesWithCompensation : paymentTypes;

  const fetchBanks = async (inputValue, callback) => {
    debounceIndexBanksRequest({
      dispatch,
      params: {
        name: inputValue,
        sort_column: 'name',
        display_length: 70
      },
      successCallback: response => {
        if (forceSetBank) {
          setAllBanks(response.data.data);
        }
        return callback(response.data.data);
      }
    });
  };

  const handlePaymentType = (field, value) => {
    setFieldValue(`${modelKey}[bank]`, '');
    if (value === 'cash' || value === 'paycheck' || value === 'compensation_fund_type') {
      setFieldValue(`${modelKey}[bankId]`, '');
    }
    if (value !== 'bank_transfer') {
      setFieldValue(`${modelKey}[bankAccount]`, '');
      setFieldValue(`${modelKey}[bankAccountHolderName]`, '');
      setFieldValue(`${modelKey}[bankAccountType]`, '');
      setFieldValue(`${modelKey}[bankAccountNationalIdentification]`, '');
    }
    if (withCompensationFund && value !== 'compensation_fund_type') {
      setFieldValue(`${modelKey}[compensationFundId]`, '');
    }
    setFieldValue(field, value); // Important to leave at the end of method
  };

  return (
    <>
      <Col md={3}>
        <Field name={`${modelKey}[paymentType]`}>
          {({ field }) => (
            <FormikSelect
              {...field}
              abbr={paymentTypeAbbr}
              isClearable={!paymentTypeAbbr}
              label="Forma de Pago"
              placeholder="Seleccionar Forma de Pago"
              onChange={data => handlePaymentType(field.name, data ? data.value : '')}
              setFieldTouched={() => setFieldTouched(field.name)}
              options={paymentOptions}
              defaultValue={paymentType}
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`${modelKey}[bankId]`}>
          {({ field }) => (
            <InputSelect
              {...field}
              abbr
              label="Banco de Pago"
              placeholder="Seleccionar Banco"
              values={currentValues}
              model={[currentModel, 'bank']}
              request={fetchBanks}
              onChange={data => {
                if (forceSetBank) {
                  const selectedBank = allBanks.filter(bank => bank.value === data.value);
                  setFieldValue(`${modelKey}[bank]`, selectedBank.length ? selectedBank[0] : '');
                }
                setFieldValue(field.name, data ? data.value : '');
              }}
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
              disabled={!(vPaymentType && (vPaymentType === 'bank_transfer' || vPaymentType === 'cashiers_check'))}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`${modelKey}[bankAccount]`}>
          {({ field }) => (
            <FormikInput
              {...field}
              abbr
              inputType="number"
              label="N° Cuenta de Pago"
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
              disabled={!(vPaymentType && vPaymentType === 'bank_transfer')}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`${modelKey}[bankAccountType]`}>
          {({ field }) => (
            <FormikSelect
              {...field}
              abbr
              label="Tipo de Cuenta"
              placeholder="Seleccionar Tipo de Cuenta"
              options={bankAccountTypes}
              defaultValue={bankAccountType}
              onChange={data => setFieldValue(field.name, data ? data.value : '')}
              setFieldTouched={() => setFieldTouched(field.name)}
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
              isDisabled={!(vPaymentType && vPaymentType === 'bank_transfer')}
            />
          )}
        </Field>
      </Col>
    </>
  );
};

export default BankAccountWithHoldings;
